import { Component, Input } from '@angular/core';
import { Road } from 'src/app/modules/route-planner/models/route-signposts-model';

@Component({
    selector: 'aa-place-of-interest-signpost',
    templateUrl: './aa-place-of-interest-signpost.component.html',
    styleUrls: ['./aa-place-of-interest-signpost.component.scss'],
    standalone: false
})
export class AaPlaceOfInterestSignpostComponent {

  @Input() road: Array<Road>;

  constructor() { }

  get roads() {
    return this.road;
  }
  
  trackByFn(index: number): number {
    return index;
  }

}
